import { geonamesApiCall } from "../thirdPartyApiBase";

const postalCodes = async (countryCode, city) => {
    const path = `postalCodeSearchJSON?placename=${city}&country=${countryCode}`
    const response = await geonamesApiCall(path, 'GET');
    return response;
}

export {
    postalCodes
}